



























































































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import {
  formatList,
} from '../../core/utils';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import { Company, Template, UsersEmails } from '../../../features/core/models/';
import { ManyRecipients, Recipient } from '../../../features/settings/models/Recipient';
import { SettingsService } from '../../../features/settings/api/SettingsService';

@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle
    }
})
export default class ModalCheckRecipients extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop({
        default() {
            return [];
        }
    })
    recipientsWithInvalidCompanies: Recipient[];
    modalTitle: string = 'Confirmación';
    submitName: string = 'Confirmar suscripción';
    errorMsg: string = '';
    pendingTable: boolean = false;
    selectedRecipients: Recipient[] = [];
    headers: Array<object> = [
        {
            text: 'Nombre',
            align: 'left',
            value: 'name'
        },
        {
            text: 'Empresa/s que NO pertenece',
            align: 'center',
            value: 'invalid_companies',
            formatter: this.formatCompanies
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];


    formatCompanies(value){
        return formatList(value, 'name');
    }

    setLoadingTable(value){
        this.pendingTable = value
    }

    excludeRecipientsFromSuscription() {
        this.removeRecipientsFromSelectedList(this.selectedRecipients);
    }

    @Watch('recipientsWithInvalidCompanies', { deep: true, immediate: true })
    observableInvalidRecipients(items) {
        // console.log("lista de destinatarios invalidos actualizada", this.recipientsWithInvalidCompanies);
        this.checkIfCanTriggerSuscription();
    }

    checkIfCanTriggerSuscription() {
        //if there are not invalid recipients
        //while modal is visible
        //trigger generate suscription
        if (this.recipientsWithInvalidCompanies.length == 0 && this.visible) {
            this.generateSuscription();
        }
    }

    @Emit()
    removeRecipientsFromSelectedList(recipients: Recipient[]) {}

    excludeRecipientFromTable(recipientToExclude) {
        this.removeRecipientsFromSelectedList([recipientToExclude]);
    }

    addCompaniesToSingleRecipient(recipientToAddCompanies) {
        this.addCompaniesToMultipleRecipients([recipientToAddCompanies]);
    }

    addCompaniesToMultipleRecipients(recipientsToAddCompanies) {
        this.setLoadingTable(true);
        let recipientsList: any = {};
        let idsToRemoveCompaniesAfterPatch: string[] = [];
        for (let index = 0; index < recipientsToAddCompanies.length; index++) {
            const recipientToPatch = recipientsToAddCompanies[index];
            const recipientToPatchValidCompanies = recipientsToAddCompanies[index]['companies'].map(function(item) {
                return item['id'];
            });
            const recipientToPatchInvalidCompanies = recipientToPatch['invalid_companies'].map(function(item) {
                return item['id'];
            });
            const allCompaniesIds = [...recipientToPatchValidCompanies, ...recipientToPatchInvalidCompanies];

            const allCompaniesObjects = [
                ...recipientsToAddCompanies[index]['companies'],
                ...recipientToPatch['invalid_companies']
            ];

            recipientsList = {
                ...recipientsList,
                [recipientToPatch['id']]: allCompaniesIds
            };
            recipientsToAddCompanies[index]['companies'] = allCompaniesObjects;
            idsToRemoveCompaniesAfterPatch.push(recipientToPatch['id']);
        }
        let recipientsToPatch: ManyRecipients = {
            recipient_companies: recipientsList
        };
        // console.log("recipientsToPatch", recipientsToPatch);
        SettingsService.patchMultipleRecipients(recipientsToPatch)
            .then(res => {
                // console.log("res", res);
                this.setLoadingTable(false);
                this.handleRecipientsOK(recipientsToAddCompanies);
            })
            .catch(err => {
                this.setLoadingTable(false);
                // console.log("res", err);
            });
    }

    handleRecipientsOK(recipientsToUpdateCompanies) {
        //luego de que los destinatarios se hayan patcheado correctamente
        //actualizo la lista de destinatarios
        this.patchRecipientsSuccess(recipientsToUpdateCompanies);
    }

    @Emit()
    generateSuscription() {
        this.closeModal();
    }

    updateSelectedRecipients(recipients: Recipient[]) {
        this.selectedRecipients = recipients;
    }

    setErrorForm(text) {
        this.errorMsg = text;
    }
    // emailsList: Array<UsersEmails> = [
    //     {
    //         email: 'jnunez@onsmartway.com',
    //         id: 1
    //     },
    //     {
    //         email: 'test@onsmartway.com',
    //         id: 2
    //     }
    // ];
    // headers: Array<object> = [
    //     {
    //         text: 'Email',
    //         align: 'left',
    //         value: 'email'
    //     }
    // ];


    resetFields() {
        // this.setErrorForm('');
    }

    @Emit()
    closeModal() {
        this.resetFields();
    }

    @Emit()
    patchRecipientsSuccess(recipientsToUpdateCompanies) {}

    mounted() {
        this.$nextTick(() => {
            // this.loadPatchData();
        });
    }
}
